import React from 'react';
import styles from './AgentList.less';
import AgentListItem from '../agentlistitem/AgentListItem';
import { PaginationContainer } from '../pagination/PaginationContainer';
import { isBasicBranchenbuchAgent } from '../../utils/AgentUtils';
import { isEmptyArray } from '../../utils/ArrayUtils';
import AgentListSkeleton from '../itemskeleton/AgentListSkeleton';
import RltTeaser from '../rltTeaser/RLTTeaser';
import { useAppDispatch, useAppSelector } from '../../store/store';
import * as actions from '../../thunks/search';
var AgentList = function AgentList() {
  var dispatch = useAppDispatch();
  var agents = useAppSelector(function (state) {
    var _state$search$alterna;
    if (state.search.totalNumberOfAgents && state.search.totalNumberOfAgents > 0) {
      return state.search.pageResults;
    }
    return ((_state$search$alterna = state.search.alternativeResults) === null || _state$search$alterna === void 0 ? void 0 : _state$search$alterna.nearbyAgents) || [];
  });
  var searchId = useAppSelector(function (state) {
    return state.tracking.searchId;
  });
  var shapeId = useAppSelector(function (state) {
    var _state$gacOverAllInfo;
    return (_state$gacOverAllInfo = state.gacOverAllInfo) === null || _state$gacOverAllInfo === void 0 || (_state$gacOverAllInfo = _state$gacOverAllInfo.selectedSuggestion) === null || _state$gacOverAllInfo === void 0 ? void 0 : _state$gacOverAllInfo.value;
  });
  var searchInProgress = useAppSelector(function (state) {
    return state.search.searchInProgress;
  });
  var currentPage = useAppSelector(function (state) {
    return state.search.currentPage || 1;
  });
  var totalPages = useAppSelector(function (state) {
    return state.search.totalNumberOfPages || 0;
  });
  var hotSeat = useAppSelector(function (state) {
    return state.search.hotSeat;
  });
  if (isEmptyArray(agents) && !hotSeat || searchInProgress) {
    return /*#__PURE__*/React.createElement(AgentListSkeleton, null);
  }
  var extendedLink = function extendedLink(agentProfilePageUrl) {
    return searchId ? "".concat(agentProfilePageUrl, "?searchid=").concat(searchId, "&geoIds=").concat(shapeId, "&referer=agent_searchresult") : agentProfilePageUrl;
  };
  var renderAgent = function renderAgent(agent) {
    return agent.agentProfilePageUrl && !isBasicBranchenbuchAgent(agent.type) ? /*#__PURE__*/React.createElement("a", {
      key: agent.id,
      className: styles.agentProfilePageUrlLink,
      href: extendedLink(agent.agentProfilePageUrl)
    }, /*#__PURE__*/React.createElement(AgentListItem, {
      agent: agent
    })) : /*#__PURE__*/React.createElement(AgentListItem, {
      key: agent.id,
      agent: agent
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "padding-bottom-xxl",
    "data-testid": "agent-list"
  }, currentPage === 1 && hotSeat && /*#__PURE__*/React.createElement("div", {
    "data-testid": "hot-seat"
  }, renderAgent(hotSeat)), agents.map(function (agent) {
    return renderAgent(agent);
  }), /*#__PURE__*/React.createElement(RltTeaser, null)), /*#__PURE__*/React.createElement(PaginationContainer, {
    currentPage: currentPage,
    totalPages: totalPages,
    updateCurrentPageNumber: function updateCurrentPageNumber(page) {
      return dispatch(actions.updateCurrentPageNumber(page));
    }
  }));
};
export default AgentList;